import { defineRouter } from '#q-app/wrappers';
import {
  createMemoryHistory,
  createRouter,
  createWebHashHistory,
  createWebHistory,
} from 'vue-router';
import routes from './routes';
import { getSubject, getSubjectFromString } from 'src/services/AppAbility';
import { LocalStorage, useQuasar } from 'quasar';

/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

export default defineRouter(function (/* { store, ssrContext } */) {
  const STORED_HISTORY_KEY = 'mes:historyKey';

  const createHistory = process.env.SERVER
    ? createMemoryHistory
    : process.env.VUE_ROUTER_MODE === 'history'
      ? createWebHistory
      : createWebHashHistory;

  const Router = createRouter({
    scrollBehavior: () => ({ left: 0, top: 0 }),
    routes,

    // Leave this as is and make changes in quasar.conf.js instead!
    // quasar.conf.js -> build -> vueRouterMode
    // quasar.conf.js -> build -> publicPath
    history: createHistory(process.env.VUE_ROUTER_BASE),
  });

  Router.beforeResolve((to, from, next) => {
    to.matched.some(async (route) => {
      const historyKey = LocalStorage.getItem(STORED_HISTORY_KEY)?.toString();
      const subject = getSubjectFromString(historyKey);

      if (
        from.name?.toString() == getSubject('Login') &&
        to.name?.toString() != subject
      ) {
        const $q = useQuasar();
        if (($q.platform.is.nativeMobile ?? false) && subject != undefined) {
          next({
            name: subject,
          });
        } else {
          next();
        }
      } else if (route.meta.requiresAuth == false) {
        next();
      } else {
        try {
          next();
        } catch (e) {
          if (e instanceof Error) {
            if (e.name == 'UserUnAuthenticatedException') {
              next({ path: '/auth/login' });
            } else {
              console.log(`${e.name}: ${e.message}`);
              throw e;
            }
          }
        }
      }
    });
  });

  Router.afterEach((to) => {
    if (to.meta.storeHistory == true && to.name) {
      LocalStorage.set(STORED_HISTORY_KEY, to.name.toString());
    }
  });

  return Router;
});
